// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\r\n/* transition组件中的name写在scoped 没有作用 */\n.formslide-enter-active, .formslide-leave-active {\r\n  -webkit-transition: all .3s;\r\n  transition: all .3s;\n}\n.formslide-enter {\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  -webkit-transform: translateX(280px);\r\n          transform: translateX(280px);\n}\n.formslide-leave-to {\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  -webkit-transform: translateX(280px);\r\n          transform: translateX(280px);\n}\r\n\r\n", ""]);
// Exports
module.exports = exports;
